import { createContext, useContext } from "react";

export const DocumentationContext = createContext({});

export const useDocumentationContext = () => useContext(DocumentationContext);
